/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class FlowBuilderAPI extends ApiClient {
  constructor() {
    super('flow_builder/flows', { accountScoped: true, apiVersion: 'v1' });
  }

  getFlows(params = {}) {
    return axios.get(this.url, { params });
  }

  getFlow(flowId) {
    return axios.get(`${this.url}/${flowId}`);
  }

  createFlow(data) {
    return axios.post(this.url, { flow: data });
  }

  updateFlow(flowId, data) {
    return axios.put(`${this.url}/${flowId}`, { flow: data });
  }

  deleteFlow(flowId) {
    return axios.delete(`${this.url}/${flowId}`);
  }

  toggleActive(flowId) {
    return axios.patch(`${this.url}/${flowId}/toggle_active`);
  }

  getExecutions(flowId, page = 1) {
    return axios.get(`${this.url}/${flowId}/executions`, { params: { page } });
  }

  getExecutionSteps(flowId, executionId, page = 1, perPage = 15) {
    return axios.get(`${this.url}/${flowId}/executions/${executionId}/steps`, {
      params: { page, per_page: perPage },
    });
  }

  getNodeStats(flowId) {
    return axios.get(`${this.url}/${flowId}/node_stats`);
  }

  getMetrics(params = {}) {
    return axios.get(`${this.url}/metrics`, { params });
  }

  getReports(flowId, params = {}) {
    return axios.get(`${this.url}/${flowId}/reports`, { params });
  }

  getAttributedOrders(flowId, params = {}) {
    return axios.get(`${this.url}/${flowId}/attributed_orders`, { params });
  }
}

export default new FlowBuilderAPI();
